import { render, staticRenderFns } from "./transporte_crud.vue?vue&type=template&id=d53f61e6"
import script from "./transporte_crud.vue?vue&type=script&lang=js"
export * from "./transporte_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports